<!-- main-layout.component.html - Modern Professional Layout -->
<div class="page">
  <!-- Full-width Header at Top -->
  <app-navbar
    [isSidebarCollapsed]="sidebar?.isCollapsed() ?? false"
    (sidebarToggle)="onSidebarToggle()"
  ></app-navbar>

  <!-- Sidebar Navigation -->
  <app-sidebar #sidebar></app-sidebar>

  <!-- Main Content Area - Same height as sidebar -->
  <div
    class="main-content app-content"
    (click)="clickOnBody()"
  >
    <app-breadcrumb [showBackButton]="false"></app-breadcrumb>
    <div class="content-area">
      @if (isLoading()) {
        <app-loader [message]="message()" />
      }

      <div class="page-content" [class.hidden]="isLoading()">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <app-footer class="footer mt-auto py-3 bg-white text-center"></app-footer>
</div>

<!-- Scroll to Top Button -->
<app-tap-to-top></app-tap-to-top>

<!-- Mobile Overlay -->
<div id="responsive-overlay" (click)="clearToggle()"></div>
